var React = require('react');

function Restore (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M11.36 8.009a.5.5 0 01-.565.701l-6.13-1.43a.5.5 0 01-.348-.679L6.861.49a.5.5 0 01.913-.023l.985 2.072A9.978 9.978 0 0112 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12v-.024c0-.267.222-.476.488-.476h2.03c.27 0 .482.23.482.5 0 3.864 3.136 7 7 7s7-3.136 7-7a7.003 7.003 0 00-8.94-6.727l1.3 2.736z"}));
}

Restore.defaultProps = {"viewBox":"0 0 24 24","sizes":"","className":"Reset__Image-sc-14320e6-0 imYYlt","width":"24","height":"24"};

module.exports = Restore;

Restore.default = Restore;
